module.exports = __webpack_public_path__ + "../resources/img/qcells-energy-solutions-bg.f29f9528.jpg";